<template>
    <div class="pc-bg-container">
        <div class="login-container">
            <div class="login-box">
                <div class="box-left">
                    <!-- <img class="logo" :src="logo" alt=""> -->
                </div>
                <div class="box-right">
                    <div class="sys-name">{{ systemName }}</div>
                    <form v-if="oprType == 'login'">
                        <div class="input-row">
                            <el-input v-model="loginInfo.account" placeholder="请输入账号"
                                class="el-input-fifty-height"></el-input>
                        </div>
                        <div class="input-row">
                            <el-input v-model="loginInfo.password" placeholder="请输入密码" class="el-input-fifty-height"
                                show-password></el-input>
                        </div>

                        <div class="input-row" style="margin-bottom: 15px;">
                            <el-button type="primary" @click="loginOnclick()" native-type="submit"
                                :loading="loginBtnIsLoading">登 录</el-button>
                        </div>
                    </form>
                    <form v-if="oprType == 'register'">
                        <div class="input-row">
                            <el-input v-model="registerForm.account" placeholder="请输入账号"
                             class="el-input-fifty-height"></el-input>
                        </div>
                        <div class="input-row">
                            <el-input v-model="registerForm.password" placeholder="请输入密码" class="el-input-fifty-height"
                              show-password></el-input>
                        </div>
                        <div class="input-row">
                            <el-input v-model="registerForm.conPassword" placeholder="请再次输入密码" class="el-input-fifty-height"
                               show-password></el-input>
                        </div>

                        <div class="input-row" style="margin-bottom: 15px;">
                            <el-button type="primary" @click="registerOnclick()" 
                            native-type="submit" 
                                :loading="loginBtnIsLoading">注 册</el-button>
                        </div>
                    </form>
                    <div class="fotget-pwd-div">
                        <span v-if="oprType == 'register'" @click="changeOprType('login')">没有账号，去注册></span>
                        <span v-if="oprType == 'login'" @click="changeOprType('register')">已有账号，去登录></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UserInfoService from "@/request-server/request-services/userinfo-services.js";
import UtilsCommon from '@/utils/utils-common';
import BrowserStorage from '@/utils/utils-browser-storage';

export default {
    props: ["redirect"],
    data() {
        return {
            systemName: "赛事报名系统",
            logo: UtilsCommon.getAssetsFiles("images/logo.jpg"),
            //登录信息
            loginInfo: {
                account: "",
                password: ""
                // company: ''
            },
            registerForm: {
                account: '',
                password: '',
                conPassword: ''
            },
            oprType: 'login',

            loginBtnIsLoading: false,
            redirectUrl: this.redirect,
        };
    },
    methods: {
        //登录点击事件
        loginOnclick() {
            if (this.loginInfo) {
                if (!this.loginInfo.account) {
                    this.$message.error("请输入账号");
                    return;
                }
                if (!this.loginInfo.password) {
                    this.$message.error("请输入密码");
                    return;
                }
            } else {
                this.$message.error("请输入账号密码");
                return;
            }

            this.loginBtnIsLoading = true;
            UserInfoService.userLogin(this.loginInfo.account, this.loginInfo.password)
                .then(resData => {
                    this.$store.commit("loginin", resData.data.LoginToken);
                    this.$store.commit("matchIdCookie", '');
                    //登录成功跳转
                    let beforeUrl = this.redirectUrl;
                    let jumpUrl = beforeUrl || "/mainpage";
                    this.$router.replace(jumpUrl);
                })
                .finally(() => {
                    this.loginBtnIsLoading = false;
                });
        },
        registerOnclick(){

        },
       
        changeOprType(type) {
            console.log(type);
            this.oprType = type;
            this.loginInfo = {
                account: "",
                password: ""
            };
            this.registerForm = {
                account: '',
                password: '',
                conPassword: ''
            }
        }
    },
    created() {
        
    }
};
</script>

<style lang="scss" scoped>
.pc-bg-container {
    width: 100%;
    height: 100%;
    // background-color: #387cbd;
    // background: linear-gradient(#559ae7, #3a8be6);

    background: url("../../assets/images/bg.jpg") no-repeat 0 0 /100% 100%;
    position: relative;
    overflow: hidden;

    .login-container {
        width: 1600px;
        height: 800px;
        // background: url("../../assets/images/bg.jpg") no-repeat 0 0 /100% 100%;
        position: relative;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        .login-box {
            width: 904px;
            height: 504px;
            overflow: hidden;
            position: relative;
            top: 154px;
            left: 345px;
            background: transparent;
            border-radius: 5px;

            .box-left {
                float: left;
                width: 518px;
                height: 504px;
                background: url("../../assets/images/page-left.jpg") no-repeat 0 0 /100% 100%;
                position: relative;

                .logo {
                    width: 57px;
                    height: 57px;
                    position: absolute;
                    top: 48px;
                    left: 37px;
                }
            }

            .box-right {
                float: left;
                width: 386px;
                height: 504px;
                background: #fff;
                // text-align: center;

                .sys-name {
                    font-size: 43px;
                    font-family: SourceHanSansCN-Light;
                    color: #56a9ff;
                    // margin-left: 52px;
                    margin-top: 58px;
                    text-align: center;
                }

                .welcome-text {
                    font-family: SourceHanSansCN-Light;
                    font-size: 20px;
                    color: #b2b4b9;
                    // margin-left: 122px;
                    margin-top: 6px;
                    text-align: center;
                }

                form {
                    width: 100%;
                    margin-top: 49px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;

                    .check-row {
                        width: 274px;
                        margin-bottom: 29px;
                        margin-top: -4px;

                        // height: 48px;
                    }

                    .input-row {
                        // width: 100%;
                        width: 274px;
                        // text-align: center;
                        margin-bottom: 29px;

                        // &:last-child {
                        //     margin-bottom: 25px;
                        // }

                        button {
                            width: 100%;
                            //height: 40px;
                            // font-family: SourceHanSansCN-Light;
                            font-size: 18px;
                            display: block;
                        }
                    }
                }
            }
        }
    }
}

.fotget-pwd-div {
    text-align: right;
    width: 274px;
    margin: 0 auto 29px auto;

    >a {
        font-size: 13px;
        color: #999999;
    }
}

.forget-pwd-dig-sel-div {
    text-align: center;

    div {
        margin: 18px;
    }
}

.forget-pwd-dig-form-div {
    ::v-deep {
        .el-input {
            margin: 10px 0;
        }
    }

    >div:nth-child(2) {
        ::v-deep {
            .el-input {
                width: 60%;
                margin-bottom: 0;
            }

            .el-button {
                margin-left: 8px;
            }
        }
    }

    >p {
        color: #999999;
        font-size: 12px;
    }

    .commit-div {
        text-align: center;
        margin: 38px 0 0 0;
    }

}

::v-deep {
    // .el-input-fifty-height input {
    //     // width: 274px;
    //     height: 40px;
    //     line-height: 40px;
    // }

    .el-checkbox__label {
        color: #71757f;
        // color: #409eff;
    }
}
</style>
